import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.subtitle}>
          Envision Integrated Services Pvt. Ltd.
        </p>
      </div>

      {/* Content */}
      <div style={styles.container}>
        <Section
          title="1. Introduction"
          text="Envision Integrated Services Pvt. Ltd. ('Company', 'we', 'our', 'us') respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services."
        />

        <Section
          title="2. Information We Collect"
          text="We may collect personal information such as your name, email address, phone number, company name, and other details when you voluntarily provide them through forms, inquiries, or service requests."
        />

        <Section
          title="3. How We Use Your Information"
          list={[
            "To provide and improve our services",
            "To respond to inquiries and customer support requests",
            "To send service-related updates and communications",
            "To comply with legal and regulatory obligations",
          ]}
        />

        <Section
          title="4. Information Sharing & Disclosure"
          text="We do not sell, trade, or rent your personal information to third parties. Information may be shared only with trusted partners for service delivery or when required by law."
        />

        <Section
          title="5. Data Security"
          text="We implement appropriate technical and organizational security measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction."
        />

        <Section
          title="6. Cookies & Tracking Technologies"
          text="Our website may use cookies and similar technologies to enhance user experience, analyze website traffic, and improve our services. You can control cookie preferences through your browser settings."
        />

        <Section
          title="7. Your Rights"
          list={[
            "Access your personal data",
            "Request correction or deletion of your information",
            "Withdraw consent where applicable",
          ]}
        />

        <Section
          title="8. Third-Party Links"
          text="Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those external sites."
        />

        <Section
          title="9. Changes to This Policy"
          text="We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated effective date."
        />

        <Section
          title="10. Contact Us"
          text="If you have any questions or concerns about this Privacy Policy, please contact us at:"
        />

        <div style={styles.contactBox}>
          <p><strong>Envision Integrated Services Pvt. Ltd.</strong></p>
          <p>Email: info@envisionservices.com</p>
          <p>Phone: +91-XXXXXXXXXX</p>
        </div>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        © {new Date().getFullYear()} Envision Integrated Services Pvt. Ltd.  
        All Rights Reserved.
      </div>
    </div>
  );
};

/* Section Component */
const Section = ({ title, text, list }) => (
  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>{title}</h2>

    {text && <p style={styles.text}>{text}</p>}

    {list && (
      <ul style={styles.list}>
        {list.map((item, index) => (
          <li key={index} style={styles.listItem}>
            {item}
          </li>
        ))}
      </ul>
    )}
  </div>
);

/* Styles */
const styles = {
  page: {
    fontFamily: "Georgia, serif",
    backgroundColor: "#104d5c",
    color: "#ffffff",
    minHeight: "100vh",
  },

  header: {
    padding: "120px 20px",
    textAlign: "center",
    // borderBottom: "1px solid rgba(255,255,255,0.2)",
  },

  title: {
    fontSize: "36px",
    margin: 0,
    color: "#ebc367", // GOLD
    letterSpacing: "1px",
  },

  subtitle: {
    marginTop: "10px",
    fontSize: "16px",
    color: "#ffffff",
    opacity: 0.9,
  },

  container: {
    maxWidth: "1100px",
    margin: "auto",
    padding: "10px 20px",
    marginTop:"-126px",
  },

  section: {
    marginBottom: "30px",
  },

  sectionTitle: {
    fontSize: "22px",
    marginBottom: "12px",
    color: "#ebc367", // GOLD
  },

  text: {
    fontSize: "16px",
    lineHeight: "1.8",
    textAlign: "justify",
    color: "#ffffff",
  },

  list: {
    paddingLeft: "20px",
    lineHeight: "1.8",
    textAlign: "justify",
  },

  listItem: {
    marginBottom: "8px",
    fontSize: "16px",
  },

  contactBox: {
    marginTop: "30px",
    padding: "20px",
    border: "1px solid rgba(235,195,103,0.4)",
    borderRadius: "8px",
    backgroundColor: "rgba(255,255,255,0.05)",
    fontSize: "16px",
  },

  footer: {
    textAlign: "center",
    padding: "20px",
    fontSize: "14px",
    borderTop: "1px solid rgba(255,255,255,0.2)",
    marginTop: "40px",
    color: "#ffffff",
  },
};

export default PrivacyPolicy;
